import { IAuctionPreview } from 'src/components/AuctionPreview/auctionPreview.i';
import styled from 'styled-components';

export const AuctionPreviewContentContainer = styled.div<IAuctionPreview>`
	padding: 0 15px;
	order: 0;

	${(props) => props.theme.desktop} {
		flex: 4;
		order: ${(props) => props.align === 'left' ? 1 : 2};
	}
`;

export const AuctionPreviewContentDates = styled.time`
	color: ${(props) => props.theme.gold[50]};
	font-size: 1.6rem;
	font-style: italic;
`;

export const AuctionPreviewContentTitle = styled.h2`
	margin: 0;
`;

export const AuctionPreviewContentLocation = styled.h4`
	margin: 0;
	color: ${(props) => props.theme.black[50]};
`;
export const AuctionPreviewContentCopy = styled.p`
	margin: 20px 0 30px;
`;

export const AuctionPreviewButtonsContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin-top: -10px;
	& > div {
		margin-top: 10px;
	}
`;

export const AuctionPreviewButtonsIndividualContainer = styled.div`
	min-width: 190px;
	display: flex;
	place-content: center;
`;

export const AuctionPreviewButtonsGap = styled.div`
	flex: 0 0 13px;
`;

export const UpcomingAuctionsButtonContainer = styled(AuctionPreviewButtonsContainer)`
	justify-content: center;
	display: flex;
`;
